import { environment } from '../../../environments/environment';
import { IBomModel, IEcommerceCart } from '../../prisma-xs/models/bom.model';
import { ILoginDetailsUser } from './user';
import { IProductCatalog } from '../../enclosure/models/catalogue.model';

const CONFIGURATOR_NAME = 'Disposuite';
const ADD_TO_CART_LOCATION = `configurator|'${ CONFIGURATOR_NAME }`;
const ITEM_CATEGORY_5 = 'commercial reference';


export enum SITE_SEARCH_CATEGORY {
  MY_PROJECTS = 'My Projects',
  SHARED_PROJECTS = 'Shared Projects',
  PENDING_SHARED_PROJECTS = 'Pending Shared Projects',
  ARCHIVED_PROJECTS = 'Archived Projects',
  ASSIGNED_COMPANY_PROJECTS = 'Assigned Company Projects',
  UNASSIGNED_COMPANY_PROJECTS = 'Unassigned Company Projects',
  ARCHIVED_COMPANY_PROJECTS = 'Archived Company Projects',
  SWITCHBOARD = 'Switchboard',
  PRISMA_SET_XL_CONFIGURATOR = 'Prisma SeT XL Configurator',
  PRAGMA_MULTI_CUSTOMIZED_CONFIGURATOR = 'Pragma Multi Customized Configurator',
}

export const ADD_TO_CART_ACTIONS = {
  COPY_TO_ORDER_AT_WHOLESALER: 'Transfer_to_Dist',
  DOWNLOAD_EXPORT: 'Download_Export',
  COPY_TO_ORDER_AT_MY_SCHNEIDER: 'Copy_to_order_at_mySchneider',
  DIRECT_TRANSFER: 'Direct_transfer',
  TRANSFER_TO_SONEPAR: 'Transfer_to_Sonepar',
  TRANSFER_TO_ELEKTROGROSSHANDEL: 'Transfer_to_Elektrogrosshandel',
  TRANSFER_TO_ELEKTRO_MATERIAL: 'Transfer_to_Elektro_Material'
}

export const VIEW_ITEM_LIST_ACTIONS = {
  BOM_WITH_PRICES: 'Bom_With_Prices',
  BOM_WITHOUT_PRICES: 'Bom_Without_Prices',
  PROJECT_BOM_WITH_PRICES: 'Project_Bom_With_Prices',
  PROJECT_BOM_WITHOUT_PRICES: 'Project_Bom_Without_Prices',
}

export const VIEW_ITEM_LIST_OPTIONS = {
  TAB_SPACE_SEPARATED_FORMAT: 'E-No. Quantity',
  CSV: '.csv',
  REFERENCE_QUANTITY_SEPARATED: 'Reference-No. Quantity',
  EXCEL: '.xlsx',
  PDF: '.pdf'
}

interface IPageViewParameters {
  event: string;
  configurator_name: string;
  digital_platform: string;
  product_country: string;
  digital_platform_country: string;
  environment: string;
  business_unit: string,
  business_division: string,
  project_id?: number;
  page_language: string;
  page_title: string;
  page_top_category: string;
  page_category: string;
  page_sub_category: string;
  page_sub_sub_category: string;
  page_path: string;
  page_scope: string;
  template: string;
  from_web_view: boolean;
  page_type: string;
  user_id: string;
}

interface ISearchParameters {
  event: string,
  site_search_category: SITE_SEARCH_CATEGORY,
  is_guided_search: boolean,
  site_search_keyword: string,
  refined_search: boolean,
  site_search_results: number,
  search_term: string
}

export interface DebouncedSearchPayload {
  searchText: string;
  results: number;
  searchCategory: SITE_SEARCH_CATEGORY;
}

interface ISearchResultClickedParameters {
  event: string,
  search_page_position: number,
  search_result_position: number,
  site_search_category: SITE_SEARCH_CATEGORY,
  site_search_keyword: string,
}

interface ICtaParameters {
  event: string;
  cta_location: string;
  cta_name: string;
  cta_link: string;
  cta_category: string;
  configurator_name: string;
  user_id: string;
}

export interface IEcommerceItem {
  item_id: string;
  item_name: string;
  configuration_id: number;
  add_to_cart_location: string;
  item_category5: string;
  price: number;
  quantity: number;
}

interface IEcommerce {
  currency: string;
  add_to_cart_location: string;
  value: number;
  items: IEcommerceItem[]
}

interface IAddToCartParameters {
  event: string;
  configurator_name: string;
  cta_name: string;
  project_id: number
  ecommerce: IEcommerce;
  user_id: string;
}

interface IDownloadParameters {
  event: string,
  document_name: string,
  document_id: string,
  document_type: string
  configurator_name: string,
  user_id: string,
}

export enum DOWNLOAD_DOCUMENTS_SHORT_NAME {
  /* Enclosure */
  BOM_WITH_PRICES = 'BWPR',
  BOM_WITHOUT_PRICES = 'BWOPR',
  BOM_WITH_PRICES_XL = 'BWPRXL',
  BOM_WITHOUT_PRICES_XL = 'BWOPRXL',
  DISPOSITON_LAYOUT_WITHOUT_COVERS = 'DLWOC',
  DISPOSITON_LAYOUT_WITH_COVERS = 'DLWC',
  ENCLOSURE_SELECTED_DOCUMENTS = 'ESD',
  SLD = 'SLD',
  ROUTINE_VERIFICATION_DOCUMENT = 'RVD',

  LABELS_FRONTSDIE = 'LBL_FS',
  LABELS_BACKSIDE = 'LBL_BS',
  RATING_PLATE = 'RP',
  RATING_PLATE_XL = 'RPXL',
  LEGEND = 'LEG',

  /* Project */
  PROJECT_BOM_WITH_PRICES = 'PBWPR',
  PROJECT_BOM_WITHOUT_PRICES = 'PBWOPR',
  PROJECT_BOM_WITH_PRICES_XL = 'PBWPRXL',
  PROJECT_BOM_WITHOUT_PRICES_XL = 'PBWOPRXL',
  PROJECT_DISPOSITON_LAYOUT_WITHOUT_COVERS = 'PDLWOC',
  PROJECT_DISPOSITON_LAYOUT_WITH_COVERS = 'PDLWC',
  PROJECT_SELECTED_DOCUMENTS = 'PSD',
  PROJECT_SLD = 'PSLD',
  PROJECT_ROUTINE_VERIFICATION_DOCUMENT = 'PRVD',

  PROJECT_ENCLOSURE_LAYOUT_WITHOUT_COVERS = 'PENCLWOC',
  PROJECT_ENCLOSURE_LAYOUT_WITH_COVERS = 'PENCLWC',

  DOWNLOAD_DATA_SHEET = 'DS'
}

export interface ILoginUser {
  company_id: string,
  company_name: string,
  is_schneider_employee: boolean,
  is_test_user: boolean,
  user_id: string,
  customer_classification_category: string,
  customer_classification_sub_category: string
}

interface IAddToLoginParameters extends ILoginUser {
  event: string;
  is_customer_impersonation: boolean;
  user_type: string;
  is_federated_id: boolean
  configurator_name: string;
}

export interface IBomAnalytics {
  copiedModels: IBomModel[];
  price: number
}

interface IViewItemEcommerce {
  item_list_name: string;
  item_list_option: string;
  item_list_location: string;
  currency: string;
  value: number;
  value_availability: boolean;
  items: IViewItemEcommerceItem[];
}

interface IViewItemEcommerceItem {
  item_id: string;
  item_name: string;
  configuration_id: number;
  item_list_name: string;
  item_list_location: string;
  item_category5: string;
  price: number;
  quantity: number;
}

export class PageViewAnalytics {
  private parameters: IPageViewParameters;

  constructor(private currentRoute: string) {
    this.createParameters();
  }

  private createParameters() {
    this.parameters = {
      event: 'page_view',
      user_id: '',
      configurator_name: CONFIGURATOR_NAME,
      digital_platform: 'Disposuite',
      product_country: 'WW',
      digital_platform_country: 'CH',
      environment: this.getEnvironmentTag(),
      business_unit: 'Energy Management',
      business_division: 'Home Solutions',
      page_language: localStorage.getItem('lang'),
      page_title: document.title,
      page_top_category: this.getPageTopCategory(this.currentRoute),
      page_category: this.getPageCategoryFromUrl(this.currentRoute),
      page_sub_category: this.getPageSubCategoryFromUrl(this.currentRoute),
      page_sub_sub_category: this.getPageSubSubCategoryFromUrl(this.currentRoute),
      page_path: this.currentRoute,
      page_scope: 'global',
      template: this.getTemplateFromUrl(this.currentRoute),
      from_web_view: false,
      page_type: this.getPageType(this.currentRoute)
    }
  }

  addProjectId(projectId: number): IPageViewParameters {
    this.parameters = {...this.parameters, project_id: projectId};
    return this.getParameters();
  }

  private getPartsOfUrl(url: string): string[] {
    const cleanedUrl = url.replace(/^\/|\/$/g, '');

    return  cleanedUrl.split('/');
  }

  private removeNumbersFromPartsOfUrl(urlParts: string[]): string[] {
    return urlParts.filter(part => !Number(part));
  }

  getPageTopCategory(url: string): string {
    if (!url) return '';

    const parts = this.getPartsOfUrl(url);

    if (parts.includes('home')) {
      return 'home';
    }

    if (parts.includes('project')) {
      return 'project';
    }
  }

  getPageCategoryFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    return this.removeNumbersFromPartsOfUrl(this.getPartsOfUrl(url))[1]?? '';
  }

  getPageSubCategoryFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    return this.removeNumbersFromPartsOfUrl(this.getPartsOfUrl(url))[2]?? '';
  }

  getPageSubSubCategoryFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    return this.removeNumbersFromPartsOfUrl(this.getPartsOfUrl(url))[3]?? '';
  }

  getTemplateFromUrl(url: string): string {
    if (!url) {
      return ''
    }

    const parts = this.getPartsOfUrl(url);

    if (parts.includes('home')) {
      return 'Home';
    }

    if (parts.includes('switchboard')) {
      return 'Configure';
    }

    return '';
  }

  getPageType(url: string): string {
    const parts = this.getPartsOfUrl(url);

   if(parts.includes('enclosure')){
    return 'enclosure';
   }
    if(parts.includes('project')){
      return 'project';
    }
    if(parts.includes('home')){
      return 'home';
    }
      return '';
  }

  private getEnvironmentTag(): string {
    return environment.tag === 'production' ? 'production' : 'development';
  }

  addFromWebView(openedFromWholeSaler: boolean)
  {
    this.parameters.from_web_view = openedFromWholeSaler;
  }

  addUserId(userId: string): IPageViewParameters {
    this.parameters.user_id = userId;
   return  this.getParameters();
  }

  getParameters(): IPageViewParameters {
    return this.parameters;
  }
}

export class AddToSearch {
  private parameters: ISearchParameters = {
    event: 'search',
    site_search_category: null,
    is_guided_search: false,
    refined_search: true,
    site_search_keyword: '',
    site_search_results: -1,
    search_term: null
  }

  static getTotalProductCount(filteredProducts: IProductCatalog[]): number {
    return filteredProducts.reduce((totalCount, catalog) => {
      return totalCount + catalog.products.length;
    }, 0);
  }

  constructor(searchText: string, results: number, searchCategory: SITE_SEARCH_CATEGORY) {
    this.parameters.site_search_keyword = searchText;
    this.parameters.search_term = searchText;
    this.parameters.site_search_results = results;
    this.parameters.site_search_category = searchCategory;
  }

  getParameters() {
    return this.parameters;
  }
}

export class AddToSearchResultClicked {
  private parameters: ISearchResultClickedParameters = {
    event: 'search_result_clicked',
    search_page_position: null,
    site_search_category: null,
    site_search_keyword: '',
    search_result_position: 0
  }

  constructor(searchText: string, searchResultPosition: number, siteSearchCategory: SITE_SEARCH_CATEGORY, searchPagePosition: number) {
    this.parameters.site_search_keyword = searchText;
    this.parameters.site_search_category = siteSearchCategory;
    this.parameters.search_result_position = searchResultPosition;
    this.parameters.search_page_position = searchPagePosition;
  }

  getParameters() {
    return this.parameters;
  }
}

export abstract class CtaAction {

  protected parameters: ICtaParameters = {
    event: 'cta_click',
    user_id: '',
    cta_location: '',
    cta_name: '',
    cta_link: '',
    cta_category: '',
    configurator_name: CONFIGURATOR_NAME
  }

  protected constructor(link: string) {
    this.parameters.cta_link = link;
  }

  addUserId(userId: string): ICtaParameters {
    this.parameters.user_id = userId;
    return this.getParameters();
  }

  getParameters(): ICtaParameters {
    return this.parameters;
  }
}

export class AddToCta extends CtaAction {
  constructor(link: string) {
    super(link);
    this.parameters.cta_name = 'Product Configurator';
    this.parameters.cta_category = 'Devices';
    this.parameters.cta_location = 'Cart';
  }
}

export class AddToCtaExternalLink extends CtaAction {
  constructor(link: string, location: string, ctaName: string) {
    super(link);
    this.parameters.cta_name = ctaName;
    this.parameters.cta_category = 'Video';
    this.parameters.cta_location = location;
  }
}

export class AddToCtaOnEnclosureActionTrigger extends CtaAction {
  constructor(link: string, location: string, ctaName: string) {
    super(link);
    this.parameters.cta_name = ctaName;
    this.parameters.cta_category = 'Enclosure';
    this.parameters.cta_location = location;
  }
}

export class AddToCtaOnProjectActionTrigger extends CtaAction {
  constructor(link: string, location: string, ctaName: string) {
    super(link);
    this.parameters.cta_name = ctaName;
    this.parameters.cta_category = 'Project';
    this.parameters.cta_location = location;
  }
}

export class AddToCartAnalytics {
  private parameters: IAddToCartParameters = {
    event: 'add_to_cart',
    user_id: '',
    configurator_name: CONFIGURATOR_NAME,
    cta_name: '',
    project_id: null,
    ecommerce: {
      add_to_cart_location: ADD_TO_CART_LOCATION,
      currency: 'CHF',
      value: 0,
      items: [],
    },
  };

  constructor(projectId: number, ctaName: string, ecommerce: IEcommerceCart) {
    this.addProjectId(projectId);
    this.addCtaName(ctaName);
    this.addEcommerce(ecommerce);
  }

  private addProjectId(projectId: number): AddToCartAnalytics {
    this.parameters.project_id = projectId;
    return this;
  }

  private addCtaName(ctaName: string): AddToCartAnalytics {
    this.parameters.cta_name = ctaName;
    return this;
  }

  private addEcommerce(ecommerce: IEcommerceCart) {
    this.parameters.ecommerce.value = ecommerce.value;
    this.parameters.ecommerce.items = [].concat(ecommerce.items
      .map(item => {
        const ecommerceItem: IEcommerceItem = {
          item_id: item.itemId,
          item_name: item.itemName,
          configuration_id: item.configurationId,
          add_to_cart_location: `${ADD_TO_CART_LOCATION}|${item.projectId}|${item.configurationId}`,
          item_category5: ITEM_CATEGORY_5,
          price: item.price,
          quantity: item.quantity
        }

        return ecommerceItem;
      }));
  }

  addUserId(userId: string): AddToCartAnalytics {
    this.parameters.user_id = userId;
    return this;
  }

  getParameters(): IAddToCartParameters {
    return this.parameters;
  }
}

interface IViewItemListParameters {
  event: string;
  configurator_name: string;
  user_id: string;
  project_id: number;
  ecommerce: IViewItemEcommerce;
}

export class ViewItemListAnalytics {
  private parameters: IViewItemListParameters = {
    event: 'view_item_list',
    configurator_name: CONFIGURATOR_NAME,
    user_id: '',
    project_id: null,
    ecommerce: {
      currency: 'CHF',
      value: 0,
      items: [],
      item_list_name: '',
      item_list_option: '',
      item_list_location: ADD_TO_CART_LOCATION,
      value_availability: true
    }
  }

  constructor(userId: string, projectId: number, ecommerce: IEcommerceCart, itemListName: string, itemListOption: string) {
    this.parameters.user_id = userId;
    this.parameters.project_id = projectId;
    this.addEcommerce(ecommerce, itemListName, itemListOption);
  }

  private addEcommerce(ecommerce: IEcommerceCart, itemListName: string, itemListOption: string) {
    this.parameters.ecommerce.value = ecommerce.value;
    this.parameters.ecommerce.item_list_name = itemListName;
    this.parameters.ecommerce.item_list_option = itemListOption;
    this.parameters.ecommerce.items = [].concat(ecommerce.items
      .map(item => {
        const viewToCartEcommerceItem: IViewItemEcommerceItem = {
          item_id: item.itemId,
          item_name: item.itemName,
          configuration_id: item.configurationId,
          item_list_name: itemListName,
          item_list_location: `${ADD_TO_CART_LOCATION}|${item.projectId}|${item.configurationId}`,
          item_category5: ITEM_CATEGORY_5,
          price: item.price,
          quantity: item.quantity
        }

        return viewToCartEcommerceItem;
      }));
  }

  getParameters(): IViewItemListParameters {
    return this.parameters;
  }
}

export abstract class DownloadAnalytics {
  protected parameters: IDownloadParameters = {
    event: 'file_download',
    user_id: '',
    document_name: '',
    document_id: '',
    document_type: '',
    configurator_name: CONFIGURATOR_NAME,
  }

  protected constructor(documentNameFull:string, documentId:number, documentType:string ,documentNameShort:string) {
    this.parameters.document_name = documentNameFull;
    this.parameters.document_type = documentType;
    this.parameters.document_id = `${documentNameShort}_${documentType}_${documentId}`;
  }

  addUserId(userId: string): IDownloadParameters {
    this.parameters.user_id = userId;
    return  this.getParameters();
  }

  getParameters() {
    return this.parameters;
  }
}

export class DownloadAnalyticsPdfFile extends DownloadAnalytics {
  constructor(documentNameFull:string, documentId:number, documentNameShort:string) {
    super(documentNameFull, documentId, 'PDF' ,documentNameShort);
  }
}

export class DownloadAnalyticsExcelFile extends DownloadAnalytics {
  constructor(documentNameFull:string, documentId:number, documentNameShort:string) {
    super(documentNameFull, documentId, 'EXCEL' ,documentNameShort);
  }
}

export class DownloadAnalyticsWordFile extends DownloadAnalytics {
  constructor(documentNameFull:string, documentId:number, documentNameShort:string) {
    super(documentNameFull, documentId, 'WORD' ,documentNameShort);
  }
}

export class DownloadAnalyticsZipFile extends DownloadAnalytics {
  constructor(documentNameFull:string, documentId:number, documentNameShort:string) {
    super(documentNameFull, documentId, 'ZIP' ,documentNameShort);
  }
}

export class AddToLoginAnalytics {
  private parameters: IAddToLoginParameters = {
    event: 'login',
    company_id: '',
    company_name: '',
    is_customer_impersonation: false,
    is_federated_id: true,
    is_schneider_employee: false,
    is_test_user: false,
    user_id: '',
    user_type: '',
    configurator_name: CONFIGURATOR_NAME,
    customer_classification_category: '',
    customer_classification_sub_category: ''
  }

  constructor(user: ILoginDetailsUser) {
    this.parameters.company_id = user.companyId;
    this.parameters.company_name = user.companyName;
    this.parameters.is_schneider_employee = user.isSchneiderEmployee;
    this.parameters.user_id = user.userId;
    this.parameters.customer_classification_category = user.customerClassificationCategory;
  }

  getParameters(): IAddToLoginParameters {
    return this.parameters;
  }
}
